<template>
  <!-- 任务管理 -->
  <div class="task-box">
    <!-- header头部 -->
    <header>
      <el-row style="margin-bottom: 20px" :gutter="20">
        <el-col :span="2">
          <el-button type="primary" @click="openAddTaskDialog"
            >添加任务</el-button
          >
        </el-col>
      </el-row>

      <el-form :inline="true" :model="query" class="demo-form-inline">
        <el-form-item>
          <el-select v-model="query.cycle" placeholder="请选择任务类型" @change="getData(1)">
            <el-option value="daily" label="普通盲盒"></el-option>
            <el-option value="battle" label="热血盲盒"></el-option>
            <el-option value="upgrade" label="幸运升级"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item>
          <el-button type="primary" @click="getData">查询</el-button>
        </el-form-item>
        <el-form-item>
          <el-date-picker
            v-model="query.start_time"
            type="datetime"
            placeholder="开始日期"
            value-format="yyyy-MM-dd HH:mm:ss"
          >
          </el-date-picker>
          -
          <el-date-picker
            v-model="query.end_time"
            type="datetime"
            placeholder="结束日期"
            value-format="yyyy-MM-dd HH:mm:ss"
          >
          </el-date-picker>
        </el-form-item>
        <el-form-item>
          <el-button type="primary" @click="handleExport">导出</el-button>
        </el-form-item>
      </el-form>
    </header>
    <!-- body内容 -->
    <div class="body-box">
      <el-table :data="taskData" v-loading="loading">
        <el-table-column prop="id" label="任务ID" align="center">
        </el-table-column>
        <el-table-column prop="cycle" label="任务类型" align="center">
          <template slot-scope="{ row }">
            <span v-if="row.cycle === 'daily'">普通盲盒</span>
            <span v-if="row.cycle === 'battle'">热血盲盒</span>
            <span v-if="row.cycle === 'upgrade'">幸运升级</span>
          </template>
        </el-table-column>
        <el-table-column prop="behavior" label="任务途径" align="center">
          <template slot-scope="{ row }">
            <span v-if="row.behavior === 1">开箱</span>
            <span v-if="row.behavior === 2">充值</span>
            <span v-if="row.behavior === 3">对战</span>
            <span v-if="row.behavior === 4">升级金额</span>
            <span v-if="row.behavior === 5">热血盲盒金额</span>
            <span v-if="row.behavior === 6">普通盲盒金额</span>
            <span v-if="row.behavior === 7">热血盲盒流水</span>
          </template>
        </el-table-column>
        <el-table-column
          prop="conditions_origin"
          label="任务箱子"
          align="center"
        >
        </el-table-column>
        <el-table-column prop="conditions" label="任务次数" align="center">
        </el-table-column>
        <el-table-column prop="reward" label="奖励金额" align="center">
        </el-table-column>
        <el-table-column prop="title" label="任务名称" align="center">
        </el-table-column>
        <el-table-column prop="weight" label="任务权重" align="center">
        </el-table-column>
        <el-table-column prop="created_at" label="创建时间" align="center">
        </el-table-column>
        <el-table-column prop="updated_at" label="更新时间" align="center">
        </el-table-column>
        <el-table-column label="操作" align="center" width="200px">
          <template slot-scope="{ row }">
            <el-button
              type="primary"
              size="small"
              @click="openEditTaskDialog(row)"
              >编辑任务</el-button
            >
            <el-button type="danger" size="small" @click="deleteTask(row)"
              >删除</el-button
            >
          </template>
        </el-table-column>
      </el-table>

      <!-- 底部分页条 -->
      <el-pagination
        background
        :page-size="dataMeta.per_page || 15"
        :total="dataMeta.total || 0"
        :current-page="dataMeta.current_page"
        @current-change="handlePageChange"
        v-if="dataMeta && dataMeta.total > dataMeta.per_page"
      ></el-pagination>
    </div>

    <!-- 弹窗 -->
    <TaskDialog
      :visible="taskVisible"
      v-model="taskInfo"
      :typeDialog="dialogType"
      @close="taskVisible = false"
      @refresh="getData"
    ></TaskDialog>
  </div>
</template>
<script>
import { mapState } from 'vuex'
import { api, delApiData, getApiData, postApiData, patchApiData } from '@/http'
import TaskDialog from './components/TaskDialog'
export default {
  components: {
    TaskDialog
  },
  data() {
    return {
      taskVisible: false,//弹显示标志
      loading: false,//加载动画
      buttonLoading: false,//按钮加载动画
      query: {//查询条件
        page: 1,
        cycle: undefined,
        start_time: '',
        end_time: ''
      },
      dialogType: 1,//弹窗类型 1是添加 2是编辑
      taskData: undefined,//任务列表
      taskInfo: undefined,//单条任务信息
      dataMeta: undefined,//底部跳转页面
    }
  },
  created() {
    this.getData()
  },
  methods: {
    getData() {
      this.loading = true
      let params = this.query
      getApiData('task', params)
        .then(res => {
          this.taskData = res.data
          //设置底部导航条数据
          this.dataMeta = res
        })
        .finally(() => {
          this.loading = false
        })

    },
    openAddTaskDialog() {
      //添加任务
      this.taskInfo = undefined,
        this.dialogType = 1
      this.taskVisible = true
    },
    openEditTaskDialog(rowInfo) {
      //编辑任务
      this.taskInfo = JSON.parse(JSON.stringify(rowInfo))
      this.dialogType = 2
      this.taskVisible = true
    },
    deleteTask(rowInfo) {
      //删除任务
      this.$confirm('确定要删除吗？', {
        type: 'warning'
      }).then(res => {
        delApiData(`task/${rowInfo.id}`).then(res => {
          this.$message.success('删除成功')
          this.getData()
        })
      }).catch(() => {

      })
    },
    handleExport() {
      //导出
      if (this.query.end_time && !this.query.start_time) {
        this.$message.error("请选择开始时间")
        return
      }

      if (this.query.start_time || this.query.end_time) {
        window.open(`${api}task_export?start_time=${this.query.start_time}&end_time=${this.params.end_time}`)
      } else {
        window.open(`${api}task_export`)
      }
    },
    handlePageChange(page) {
      //页面底部跳转页面
      this.query.page = page
      this.getData();
    },
  }

}
</script>
<style lang="less" scoped>
</style>